import FormJaivana from "dashboard_jaivana_v1";
/**
 *
 * @author Santiago_Hernandez
 */
/**
 * Custom con funciones adicionales al formulario de ProduccionProductosKits (Combinacion entre CRUD sencillo y un poco de Controlador)
 **/


class CustomCrearFichaProduccion extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.onClickNew                 = this.handlerClickNew.bind(this);
        this.successLote                = this.successLote.bind(this);
        this.verificarPuntos            = this.verificarPuntos.bind(this);
        this.cantidaMaximaPuntos        = 0;
        this.mostrarPuntos              = false;
        this.limpiarCampos              = this.limpiarCampos.bind(this);
        this.limpiarCampos2             = this.limpiarCampos2.bind(this);
        this.validarPuntos              = this.validarPuntos.bind(this);
        this.puntosValidos              = true;
        this.cantidadProducir           = 0;
        this.validarPuntos2             = this.validarPuntos2.bind(this);
        this.onClickSave                = this.handlerClickSave.bind(this);
        this.validarFechas              = this.validarFechas.bind(this);
        this.validarLosPuntos           = this.validarLosPuntos.bind(this);

    }

    initForm() {
        console.log('Crear ficha @version 1.00010.01, @author Cristian Ciro');
        this.getField('tipo_ficha').setOnChange(this.limpiarCampos);
        this.getField('codigo_producto_formulacion').setOnChange(this.limpiarCampos2);
        this.getField('puntos').setKeyUp(this.validarPuntos);
        this.getField('cantidad_a_producir').setKeyUp(this.validarPuntos2);

        this.getField("articulo_id").setOnChange(this.validarLosPuntos);
    }

    validarLosPuntos(){
        if(this.getField('articulo_id').getValue() !== ""){
            let datos = {
                datos:{
                    value:this.getField('articulo_id').getValue()
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-articulo', operacion: 'puntos', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.verificarPuntos,
                error: this.error_,
                general: this.generalFormatPmv
            });
        }
    }

    handlerClickNew(props){
        //Se configura el campo fecha trayendo GETDATE (Fecha actual - momento)
        let fecha = new Date();
        let hora = fecha.toLocaleTimeString('en-GB');
        let anio_actual = fecha.getFullYear();
        let mes_actual = (fecha.getMonth()+1 < 10)?'0'+(fecha.getMonth()+1):fecha.getMonth()+1;
        let dia_actual = (fecha.getDate()<10)?'0'+fecha.getDate():fecha.getDate();
        fecha = anio_actual+'-'+mes_actual+'-'+dia_actual;
        console.log("Hora = ",hora);

        this.getField("hora").setValue(hora);

        let datos = {
            datos:{
                codigo:'0001', 
                fecha: fecha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-consecutivos', operacion: 'codigofecha', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successLote,
            error: this.error_,
            general: this.generalFormatPmv
        });
        
        /*let body = {
            codigo:'0001', 
            fecha: fecha,
        }
        this.generalFormat.nombre_accion = '252-Busca_los_consecutivos_por_codigo_y_la_fecha'; //Se consume este servicio que trae los datos
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successLote,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successLote(data){ //Aqui lo que se hace es tomar el data que devuelve el servicio tomar el lote y ponerlo para que no sea modificado 
        if(data.estado_p === 200){
            this.toggleFields(false);
            this.toggleButton(false);
            this.buttonsActions.map(btn=>{
                console.log("this.buttons = ",this.refsJaivana);
                if(this.refsJaivana[btn] !== undefined && this.refsJaivana[btn]!==null)
                    this.refsJaivana[btn].setVisible(true);
                return null;
            });
            this.clearFields();
            this.getField("tableShowDataPag").toggle(false);
            let datamodel = data.model;
            this.getField('lote').setValue(datamodel[0].numero);
        }
    }

    verificarPuntos(data){ 
        //Cuando se esta creando la nueva ficha al usar el buscador de producto el cual nos atrae el articulo_id consume un servicio que esta configurado en la BD
        //y el data que trae se toma y se grafica haciendo la validacion que el data contena datos si no no se muestra la tabla ni el campo de puntos
        if(data.data.length > 0){
            this.getField('tipo_ficha').setValue('N');
            //this.gridOptionsCrear['rowData'] = data;
            this.getField('puntos').setVisible(true);
            this.getField('puntos').setValue(data.data[0].puntos);
            this.cantidaMaximaPuntos = data.data.puntos;
            //this.getField('tablaPuntosCrear').initData(this.gridOptionsCrear);//
            this.mostrarPuntos = true;
        }else{
            this.getField('puntos').setVisible(false);
            //this.getField('tablaPuntosCrear').toggle(false);
            this.mostrarPuntos = false;
        }
    }

    limpiarCampos(){ //Cuando el campo ficha libre se activa la N desaparece la tabla consultada con productos y el campo puntos si se pone S (No se mueve) Deja la tabla y el campo puntos
        if(this.getField('tipo_ficha').getValue() === 'N'){
            this.getField('puntos').setValue(0);
            this.getField('puntos').setVisible(false);
            //this.getField('tablaPuntosCrear').toggle(false);
        }else if(this.getField('tipo_ficha').getValue() === 'S' &&  this.mostrarPuntos){
            this.getField('puntos').setValue(0);
            this.getField('puntos').setVisible(true);
            //this.getField('tablaPuntosCrear').toggle(true);
        }
    }

    limpiarCampos2(){ //El limpiar campos 2 se usa cuando el usuario borra el codigo que esta escribiendo en codigo producto
        this.getField('puntos').setVisible(false);
        //this.getField('tablaPuntosCrear').toggle(false);
        this.getField('nombre_producto_formulacion').setValue('');
       // this.getField('articulo_id').setValue('');
    }

    validarPuntos(){
        if(this.getField('puntos').valid()){
            if(parseInt(this.getField('puntos').getValue()) > this.cantidaMaximaPuntos || this.getField('puntos').getValue() < 0){
                this.getField('puntos').setError(true,'* Este Valor no puede ser mayor a la cantidad de puntos ni menor a cero');
                this.puntosValidos = false;
            }else{
                this.puntosValidos = true;
                this.getField('puntos').setError(false,'');
                if(this.getField('cantidad_a_producir').getValue() !== '' && this.getField('cantidad_a_producir').getValue())
                    if(this.getField('puntos').getValue() !== '' && this.getField('puntos').getValue())
                        this.getField('cantidad_a_producir').setValue(this.cantidadProducir-this.getField('puntos').getValue());
                else
                    if(this.getField('puntos').getValue() !== '' && this.getField('puntos').getValue())
                        this.getField('cantidad_a_producir').setValue(this.cantidadProducir-this.getField('puntos').getValue());
            }
        }
    }

    validarPuntos2(){
        this.puntosValidos = true;
        if(this.getField('cantidad_a_producir').getValue() !== '')
            this.cantidadProducir = this.getField('cantidad_a_producir').getValue();
        else 
            this.cantidadProducir = 0;
        this.getField('puntos').setValue(0);
    }

    handlerClickSave(){// Al darle en el boton guardar se consume el servicio que permite crear una ficha enviando el en el body los campos necesarios  
        this.getField('fecha').setError(false,'');
        let fecha_ac = "";
        let valid = false;
        if(this.getField('fecha') !== '' ){
            if(this.getField('fecha'))
            fecha_ac = this.getField('fecha').getValue();
            if(fecha_ac.split("-")){
                if(this.validarFechas(this.getField('fecha').getValue(),this.getField('fecha').getValue(),2)){
                    valid = true;
                    this.getField('fecha').setError(false,'');
                }else{
                    valid = false;
                    this.getField('fecha').setError(true,'* Esta fecha debe ser mayor o igual a la fecha actual');
                }
            }else{
                if(this.validarFechas(this.getField('fecha').getValue(),this.getField('fecha').getValue(),2)){
                    valid = true;
                    this.getField('fecha').setError(false,'');
                }else{
                    valid = false;
                    this.getField('fecha').setError(true,'* Esta fecha debe ser mayor o igual a la fecha actual');
                }
            }
        }
        
        if (valid === true){
            if (this.getField('cantidad_a_producir').getValue() > 0){
                let datos = {
                    datos:{
                        lote:this.getField('lote').getValue(),
                        descripcion:this.getField('descripcion').getValue(),
                        proceso_configuracion_id: 1,
                        cantidad_a_producir: this.getField('cantidad_a_producir').getValue(),
                        actividad_configuracion_id: 7,
                        formulacion_id: this.getField('formulacion_id').getValue(),
                        tipo_ficha: this.getField('tipo_ficha').getValue() === 'S'?'L':'N',
                        puntos:this.getField('puntos').getValue(),
                    }
                }

                this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'crear', operacion_tipo: 'crear' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'POST',
                    body: datos,
                    success: this.successSave,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
                /*this.generalFormat.nombre_accion = '252-Permite_crear_una_ficha';
                this.service.send(
                    {
                        endpoint:this.constant.formConfiguration(),
                        method:'POST',
                        body:body,
                        success:this.successSave,
                        error:this.error_,
                        general: this.generalFormat
                    });*/

            }else{
                this.getField('fieldAlert').toggle(true,"La cantidad a producir debe ser mayor a cero","error");
            }        
        }else{
            this.getField('fieldAlert').toggle(true,"Elegir una fecha que sea mayor o igual a la fecha actual","error");
        }
    }

    validarFechas(fecha1,actual){
 
        let dia = parseInt(fecha1.split('-')[2]);

        let mes = parseInt(fecha1.split('-')[1]);

        let anio = parseInt(fecha1.split('-')[0]);

        let valid = true;
        if(dia >= parseInt(fecha1.split('-')[2])){
            let actual = new Date();
            let anio_actual = actual.getFullYear();

            let mes_actual = actual.getMonth()+1;
 
            let dia_actual = actual.getDate();

            if(anio > anio_actual)
                valid = true;
            else if(anio === anio_actual){
                if(mes > mes_actual)
                    valid = true;
                else if(mes === mes_actual){
                    if(dia >= dia_actual)
                        valid = true;
                    else
                        valid = false;
                }else
                    valid = false
            }else
                valid = false;
        }
        return valid;   
    }
}

FormJaivana.addController("prod-fichas",CustomCrearFichaProduccion);
export default CustomCrearFichaProduccion;